// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cY8kt{width:100%;flex-direction:column}.cY8kt>div{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `cY8kt`
};
export default ___CSS_LOADER_EXPORT___;
